import { IObjKeyNum } from '~/data/car/carColors';
import { useCallback } from 'react';

function useStringTemplate(): (
  template: string | undefined,
  templateValues: IObjKeyNum,
) => string {
  const replaceTemplateValues = useCallback(
    (template: string | undefined, templateValues: IObjKeyNum) => {
      if (!template) return '';

      return template.replace(/{(.*?)}/g, (match, key) =>
        templateValues[key] !== undefined ? templateValues[key] : match,
      );
    },
    [],
  );

  return replaceTemplateValues;
}

export default useStringTemplate;
